import React from 'react';
import { Navbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faUser, faLayerGroup, faSignOutAlt, faNewspaper } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import SecureLS from 'secure-ls';

var ls = new SecureLS({
  encodingType: 'aes',
  isCompression: false,
  encryptionSecret: '1e83a92d7d078016391819c4ab7bd561'
});

const fn_set_footer = (bbsYn) => {
  if (bbsYn !== '') ls.setDataToLocalStorage('BBS_YN', bbsYn);
  let BBS_YN = ls.getDataFromLocalStorage('BBS_YN') === 'undefined' ? '' : ls.getDataFromLocalStorage('BBS_YN');
  let notice = null;
  if (BBS_YN === 'Y') notice = <div><Link to='/stdt/notice'><FontAwesomeIcon icon={faNewspaper} /><br />학교공지</Link></div>;
  return (
    <footer>
      <Navbar bg='light' className='stdtMenu' fixed='bottom'>
        {notice}
        <div><Link to='/stdt/ruleList'><FontAwesomeIcon icon={faList} /><br />내역</Link></div>
        <div><Link to='/stdt/ruleInfoList'><FontAwesomeIcon icon={faLayerGroup} /><br />규정</Link></div>
        <div><Link to='/stdt/myInfo'><FontAwesomeIcon icon={faUser} /><br />내정보</Link></div>
        <div id="logoutBtn"><FontAwesomeIcon icon={faSignOutAlt} /><br />로그아웃</div>
      </Navbar>
    </footer>);
}

export default fn_set_footer;